"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _camelize = _interopRequireDefault(require("camelize"));
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _includes = _interopRequireDefault(require("lodash/includes"));
var _map = _interopRequireDefault(require("lodash/map"));
/**
 * Utilities for working with objects.
 * @module ObjectUtils
 */
const ObjectUtils = {
  /**
   * Creates a query string representation of an object.
   * @deprecated Use UrlUtils.createQueryString instead
   * @static
   * @function querify
   * @param {Object} ob - The object to querify.
   * @example
   * ObjectUtils.querify({foo: 'hello', baz: 'there'});
   * @returns {String} - The query string output.
   */
  querify(ob) {
    return (0, _map.default)(ob, (value, key) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }).join('&');
  },
  /**
   * Returns the properties of an object whose keys partially match the provided string.
   * @static
   * @function getPartialMatchedProps
   * @param {Object} ob - The object to get properties from.
   * @param {String} match - The string to match keys against.
   * @example
   * ObjectUtils.getPartialMatchedProps({foo: 'foo', baz: 'baz', fool: 'fool'}, 'foo');
   * @returns {Object} - The object containing only the properties whose keys partially matched.
   */
  getPartialMatchedProps(ob, match) {
    const matched = {};
    (0, _forEach.default)(ob, (value, key) => {
      if ((0, _includes.default)(key, match)) {
        matched[key] = value;
      }
    });
    return matched;
  },
  /**
   * Converts the keys of an object into camelCase.
   * @static
   * @function camelizeKeys
   * @param {Object} data - The input object to camelize keys of.
   * @example
   * ObjectUtils.camelizeKeys({
   *     available_inventory: {
   *         start_timestamp: '2020-03-17T12:30:00.000Z',
   *         end_timestamp: '2020-03-17T20:30:00.000Z',
   *         number_of_spots: 20,
   *     },
   * });
   * @returns {Object} - The output object with camelCase keys.
   */
  camelizeKeys(data) {
    return (0, _camelize.default)(data);
  }
};
var _default = exports.default = ObjectUtils;